import React from 'react';
import { Flex, SkeletonText } from '@cko/primitives';
import { StyledSkeleton } from './PanelHeaderPlaceholder.styles';
const elementHeight = 'var(--layout-shoebox)';
export const PanelHeaderPlaceholder = () => {
    return (React.createElement(Flex, { justifyContent: "space-between", flexWrap: "wrap", gridGap: elementHeight, alignItems: "center" },
        React.createElement(Flex, { alignItems: "center", height: elementHeight },
            React.createElement(Flex, { borderRight: "var(--base-border-secondary)", height: elementHeight, pr: "var(--layout-spoon)", mr: "var(--layout-spoon)" },
                React.createElement(StyledSkeleton, null,
                    React.createElement(SkeletonText, null))),
            React.createElement(StyledSkeleton, null,
                React.createElement(SkeletonText, null))),
        React.createElement(Flex, { height: elementHeight },
            React.createElement(StyledSkeleton, null,
                React.createElement(SkeletonText, null)))));
};
